import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import Loading from "../components/Loading";
import { createLogger } from "../helper/logger";
import useAuthenticatedPage from "../hooks/useAuthenticatedPage";

const Protected = ({ children, component }) => {
	const logger = useMemo(() => createLogger("Protected"), []);
	const { userRole, inProgress, shouldBlockPage } = useAuthenticatedPage();

	if (inProgress !== "none") {
		logger.debug("Authentication in progress", { inProgress });
		return <Loading />;
	}

	if (shouldBlockPage) {
		return <Navigate to="/" replace />;
	}

	if (component === "permanent-issue-register" && userRole !== "ADMIN") {
		return <Navigate to="/" replace />;
	}

	return children;
};
export default Protected;
